import { login } from './modules/auth';
import { fetchPins } from './modules/pins';
import { fetchTemplates } from './modules/templates';
import {fetchPlaces} from "./modules/places";
import {fetchIntroductions} from "./modules/introductions";
import {fetchActivities} from "./modules/activities";
import {fetchInstitutions} from "./modules/institutions";

export const restoreSession = () => dispatch => {
  const token = localStorage.getItem('token');
  if (token) dispatch(login(token));
};

export const fetchContent = () => dispatch => {
  dispatch(fetchPlaces());
  dispatch(fetchTemplates());
  dispatch(fetchInstitutions());
  dispatch(fetchActivities());
  dispatch(fetchIntroductions());
  dispatch(fetchPins());
};



// WEBPACK FOOTER //
// ./src/store/actions.js